import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { CustomFieldService } from 'src/app/profiles/shared/custom-field.service';
import { CustomFieldDto } from 'src/app/profiles/shared/dto/custom-field.dto';
import { CustomFieldMetadataLego } from '../../shared/dto/custom-field-metadata.lego';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-custom-field-lego-edit',
  templateUrl: './custom-field-lego-edit.component.html',
  styleUrls: ['./custom-field-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class CustomFieldLegoEditComponent implements OnInit {
  @Input() customFieldData: CustomFieldMetadataLego;
  customFields: Array<SelectItem>;

  constructor(private _customFieldService: CustomFieldService) {}

  ngOnInit(): void {
    this._customFieldService.searchCustomFields().then(
      (data) =>
        (this.customFields = data.Result.map((cF) => {
          return { label: cF.Name, value: cF.CustomFieldID } as SelectItem;
        }))
    );
  }

  customFieldChanged(customFieldId: number) {
    this.customFieldData.Label = this.customFields.find((x) => x.value == customFieldId).label;
  }
}
